import React from 'react';
import { BaseSelect } from 'src/components/common';
import { PBaseSelect } from 'src/components/common/selects/BaseSelect/BaseSelect';

const genderOptions = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Transgender', label: 'Transgender' },
  { value: 'Non-Binary', label: 'Non-Binary' },
  { value: 'Prefer Not To Say', label: 'Prefer Not To Say' },
];

export const GenderSelect: React.FC<PBaseSelect> = (props) => {
  return <BaseSelect options={genderOptions} withoutSearch {...props} />;
};
